// React Imports
import React, { useEffect, useRef, useState } from "react";

// Router Imports
import { useLocation, useNavigate } from "react-router-dom";

// Redux Imports
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../redux/features/sharedResources/sharedResources.js";

import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";

// Utils Imports
import useCustomSearchParams from "../../../utils/useCustomSearchParams.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider.js";

// Component Imports
import Loader from "../../../components/Loader/Index.jsx";
import PaginationComponent from "../../../components/_utils/PaginationComponent/index.jsx";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import ApprovalTopNavComponent from "../../../components/_utils/CommonTopNav/ApprovalTopNav/index.jsx";
import FieldForceRequestTxnMultiCard from "../../../components/FieldForceRequestTransactionComp/FieldForceRequestTxnMultiCard/index.jsx";
import {
  approveFieldForceRequest,
  resetFieldForceMultiApprovalError,
  resetFieldForceMultiDeniedApprovalData,
} from "../../../redux/features/fieldForceRequest/index.js";
import FieldForceAccountDetailsPopup from "../../../components/_utils/FieldForceAccountDetailsPopup/index.jsx";
import FieldForceReqTxnDetailsPopup from "../../../components/FieldForceRequestTransactionComp/FieldForceReqTxnDetailPopup/index.jsx";
import ICONS from "../../../assets/Icons/index.js";
import UseHandleScroll from "../../../hooks/useHandleScroll.js";

const FieldForceRequestMultiApproval = () => {
  // 1️⃣ useDispatch & Router hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const dropdownOptionsForUrl = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptionsForUrl[0],
  });

  // 2️⃣ useRef
  const filterRef = useRef(null);

  // 3️⃣ useState
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountNo: "",
    bankAccountIFSC: "",
    ownerAccountId: "",
    requested_amount: "",
    ownerbankAccountNo: "",
  });
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [selectedSendTransactions, setSelectedSendTransactions] = useState([]);
  const [totalAmount, setTotalAmount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [allAccounts, setAllAccounts] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [selectAllCard, setselectAllCard] = useState(false);
  const [label, setlabel] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [txnlabels, settxnLabels] = useState([]);
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [page, setPage] = useState(
    Number(searchParam.get("pageno")) || GlobalConfiguration.lengthCheckOne,
  );
  const [dropdownOptions] = useState(PaginationConfiguration.paginationOptions);
  const [mainData, setMainData] = useState([]);
  const [totalCount, setTotalCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [approvedAccounts, setApprovedAccounts] = useState([]);
  const [initCategoryFilter, setInitCategoryFilter] = useState(
    searchParam.get("category_id") || "",
  );
  const [displayCategory, setDisplayCategory] = useState(
    searchParam.get("dispCat") || "",
  );
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") ||
      (window.innerWidth >= GlobalConfiguration.innerWidthLargeSize
        ? PaginationConfiguration.paginationMid
        : window.innerWidth >= GlobalConfiguration.innerWidthMidSize
          ? PaginationConfiguration.paginationExtraSmall
          : PaginationConfiguration.paginationSmall),
  );
  const [isOpen, setIsOpen] = useState(false);
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const [datas, setDatas] = useState([]);
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    GlobalConfiguration.internalTxnCardHoverHeight,
  );

  // 4️⃣ useSelector
  const {
    fieldForceRequestMultiApprovalError,
    fieldForceRequestMultiDeniedApprovalError,
  } = useSelector((state) => state?.fieldForceRequest);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  // 5️⃣ Constants
  const conditionVarLengthOne = GlobalConfiguration.lengthCheckOne;
  const conditionVarLengthTwenty = GlobalConfiguration?.panLength;
  const shouldShowPagination =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count > GlobalConfiguration?.lengthCheckZero &&
    allAccounts.length > GlobalConfiguration?.lengthCheckZero;

  // 6️⃣ Callback / Handler functions
  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };
  const fetchData = async () => {
    setLoadingData(true);

    let data = [];
    switch (active) {
      case "Category": {
        const response = await dispatch(
          getAllCategories({ search_string: searchUserTextDebounce }),
        );
        data =
          response?.payload?.categories?.map((itm) => ({
            id: itm.id,
            Category: itm.name,
            Description: itm?.description || "Not given",
          })) ?? [];
        break;
      }
      case "Labels":
        data =
          txnlabels
            ?.filter((itm) => itm.includes(searchUserTextDebounce))
            ?.map((val) => ({ id: val, Label: val })) ?? [];
        break;
      default:
        break;
    }
    setInputData(data);
    setLoadingData(false);
  };

  useEffect(() => {
    const MAX_LIMIT = GlobalConfiguration?.panLength;

    if (selectedTransactions.length > MAX_LIMIT) {
      setSelectedTransactions((prev) => prev.slice(0, MAX_LIMIT));
      setSelectedSendTransactions((prev) => prev.slice(0, MAX_LIMIT));
    }
  }, [selectedTransactions]);
  useEffect(() => {
    const amt = selectedSendTransactions.reduce(
      (sum, account) => sum + Number(account.requested_amount || 0),
      0,
    );
    setTotalAmount(amt);
  }, [selectedSendTransactions]);

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active, searchUserTextDebounce]);

  const fetchTransactions = async () => {
    setAllBeneTxnAccountsLoading(true);

    try {
      let queryParams = {
        page_no: page,
        page_size: pageSize,
      };

      if (LabelSearchText?.length > GlobalConfiguration.lengthCheckZero) {
        queryParams.labels = LabelSearchText;
      }

      if (initCategoryFilter !== "") {
        queryParams.category_id = initCategoryFilter;
      }

      const response = await dispatch(approveFieldForceRequest(queryParams));

      const newData = response?.payload?.requests || [];
      const formattedData =
        newData?.map((account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        })) || [];

      setTotalCount(
        response?.payload?.total_count || GlobalConfiguration.lengthCheckZero,
      );
      setMainData(response?.payload);

      setAllAccounts(formattedData);

      const approved = newData.filter(
        (account) =>
          account?.field_force_account_approval_status === "approved",
      );
      setApprovedAccounts((prevApproved) => [...prevApproved, ...approved]);
    } catch (error) {
      console.error("Failed to fetch transactions:", error);
      setMainData([]);
      setAllAccounts([]);
    } finally {
      setAllBeneTxnAccountsLoading(false);
    }
  };

  const onMount = () => {
    let availableLabels = sessionStorage?.getItem(
      "AvailableLabelsFieldForceRequest",
    );
    if (availableLabels) {
      try {
        const parsedLabels = JSON?.parse(availableLabels);
        settxnLabels(parsedLabels || []);
      } catch (error) {
        console.error("Error parsing labels from sessionStorage:", error);
        settxnLabels([]);
      }
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  useEffect(() => {
    dispatch(resetFieldForceMultiApprovalError());
    dispatch(resetFieldForceMultiDeniedApprovalData());
  }, [
    dispatch,
    fieldForceRequestMultiApprovalError,
    fieldForceRequestMultiDeniedApprovalError,
  ]);

  useEffect(() => {
    fetchTransactions();
  }, [page, pageSize, initCategoryFilter, LabelSearchText, markerData]);

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);

    setPage((prevPage) => {
      if (newTotalPages === GlobalConfiguration.lengthCheckZero) {
        return GlobalConfiguration.lengthCheckOne;
      }
      if (prevPage > newTotalPages) {
        return newTotalPages;
      }
      return prevPage;
    });
  }, [totalCount, pageSize]);

  const handleSelectAll = (tt) => {
    const MAX_LIMIT = GlobalConfiguration?.panLength;
    const alreadySelectedCount = selectedTransactions?.length;
    const remainingSelections = MAX_LIMIT - alreadySelectedCount;

    if (tt) {
      const currentViewIds = approvedAccounts.map((itm) => itm.request_id);

      const filteredIds = selectedTransactions.filter(
        (id) => !currentViewIds.includes(id),
      );
      const filteredData = selectedSendTransactions.filter(
        (itm) => !currentViewIds.includes(itm.request_id),
      );

      setSelectedTransactions(filteredIds);
      setSelectedSendTransactions(filteredData);
    } else {
      if (remainingSelections <= 0) {
        setSelectedTransactions([]);
        setSelectedSendTransactions([]);
      } else {
        const newItemsToAdd = allAccounts
          .filter(
            (account) =>
              account?.field_force_account_approval_status === "approved" &&
              !selectedTransactions.includes(account.request_id),
          )
          .slice(0, remainingSelections);

        const newIds = newItemsToAdd.map((account) => account.request_id);

        setSelectedTransactions((prev) => [...prev, ...newIds]);
        setSelectedSendTransactions((prev) => [...prev, ...newItemsToAdd]);
      }
    }
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    const nextPage = Number(page) || GlobalConfiguration.lengthCheckOne;
    setPage(nextPage);
    handleSearchParams("pagesize", value);
    handleSearchParams("pageno", nextPage);
  };

  const handlePagination = (pageNum) => {
    setDirection("");
    setPage(pageNum);
    handleSearchParams("pageno", pageNum);
  };
  useEffect(() => {
    const handlefilter = (e) => {
      if (filterRef.current && filterRef.current.contains(e.target)) {
        setShowSearchBar(false);
      }
    };
    document.addEventListener("click", handlefilter);
    return () => document.removeEventListener("click", handlefilter);
  }, []);

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };
  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };
  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  // useEffect(() => {
  //   setDatas({
  //     ...datas,
  //     owner_account_balance_last_fetched_at_in_words:
  //       beneTxnAccountData?.transaction[GlobalConfiguration.lengthCheckZero]
  //         ?.owner_account_balance_last_fetched_at_in_words,
  //     owner_account_balance:
  //       beneTxnAccountData?.transaction[GlobalConfiguration.lengthCheckZero]
  //         ?.owner_account_balance,
  //     owner_account_balance_last_fetched_at:
  //       beneTxnAccountData?.transaction[GlobalConfiguration.lengthCheckZero]
  //         ?.owner_account_balance_last_fetched_at,
  //   });
  // }, [beneTxnAccountData]);

  const SideDrawerOpen = async (id, txnId) => {
    SetBeneTxnDetailsId(id);
    setisDrawerOpen(!isDrawerOpen);
  };
  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      initCategoryFilter !== "" ||
        LabelSearchText?.length > GlobalConfiguration.lengthCheckZero,
    );
  };
  useEffect(() => {
    updateIsFilterApplied();
  }, [initCategoryFilter, LabelSearchText]);
  const handleClearParams = () => {
    setInitCategoryFilter("");
    setDisplayCategory("");
    setlabel([]);
    setLabelSearchText([]);
    setTxnPayLoad((prev) => ({
      ...prev,
      requested_amount: "",
      bankAccountNo: "",
    }));
    setPage(GlobalConfiguration.lengthCheckOne);
    navigate(
      {
        pathname: location.pathname,
        search: `?pageno=${GlobalConfiguration.lengthCheckOne}&pagesize=${dropdownOptionsForUrl[0]}`,
      },
      { replace: true },
    );
  };
  return (
    <>
      {showTxnDetailPop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <FieldForceReqTxnDetailsPopup
            field_force_request_id={txnId}
            closePopup={() => {
              closeBeneTxnDetailModal();
            }}
            RequestHeader={"Request details"}
            type={"reimbursereq_details"}
          />
        </div>
      )}
      {isDrawerOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <FieldForceAccountDetailsPopup
            field_force_account_id={BeneTxnDetailsId}
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            type={"reimburseacc_details"}
            setAllAccounts={setAllAccounts}
            onSuccess={fetchTransactions}
          />
        </div>
      )}

      <div
        className={` bg-primary-bg flex flex-col h-screen relative overflow-hidden`}
        style={{
          background: showInnerSearchBar ? "var(--bg-PopUp-BackDrop)" : "",
        }}
      >
        <div className="w-width-full h-height-full">
          <div className="w-width-full h-height-full relative z-z-index-content flex flex-col overflow-y-hidden overflow-x-hidden">
            <div
              className={`w-width-full h-navbar-breadcrumb-height Qmd:block hidden ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"}  flex-shrink-0`}
            ></div>
            <div className="relative z-z-index-overlay">
              <ApprovalTopNavComponent
                direction={direction}
                ispagination={shouldShowPagination}
                handleBack={() =>
                  navigate(GlobalConfiguration.lengthCheckNegativeOne)
                }
                isSelectionView={true}
                topNavHeader={totalAmount}
                topNavSubText={"Total amount"}
                selectionText={`Requests selected : ${selectedTransactions?.length}`}
                selectionBtnProps={
                  !shouldShowPagination
                    ? undefined
                    : {
                        btnText: "Select up to 10",
                        btnType: "button",
                        enabledBgColor:
                          selectedTransactions?.length <
                            GlobalConfiguration?.panLength &&
                          approvedAccounts.length !==
                            GlobalConfiguration?.lengthCheckZero &&
                          approvedAccounts.every((itm) =>
                            selectedTransactions.includes(itm.request_id),
                          )
                            ? "var(--positive-bg)"
                            : selectedTransactions?.length ===
                                GlobalConfiguration?.panLength
                              ? "var(--positive-bg)"
                              : "var(--primary-nav-act)",
                        hoverOption:
                          selectedTransactions?.length <
                            GlobalConfiguration?.panLength &&
                          approvedAccounts.length !==
                            GlobalConfiguration?.lengthCheckZero &&
                          approvedAccounts.every((itm) =>
                            selectedTransactions.includes(itm.request_id),
                          )
                            ? "black"
                            : selectedTransactions?.length ===
                                GlobalConfiguration?.panLength
                              ? "black"
                              : "white",
                        enabledTextColor: "var(--text-primary)",
                        icon:
                          selectedTransactions?.length <
                            GlobalConfiguration?.panLength &&
                          approvedAccounts.length !==
                            GlobalConfiguration?.lengthCheckZero &&
                          approvedAccounts.every((itm) =>
                            selectedTransactions.includes(itm.request_id),
                          )
                            ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                            : selectedTransactions?.length ===
                                conditionVarLengthTwenty
                              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                              : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                        handleFunction: () => {
                          setselectAllCard(
                            approvedAccounts.every((itm) =>
                              selectedTransactions.includes(itm.request_id),
                            )
                              ? true
                              : selectAllCard
                                ? false
                                : true,
                          );
                          handleSelectAll(
                            approvedAccounts.every((itm) =>
                              selectedTransactions.includes(itm.request_id),
                            ),
                          );
                        },
                      }
                }
                topNavCtaBtn2Props={{
                  btnText: "Next",
                  btnType: "button",
                  enabledBgColor: "var(--text-primary)",
                  inActiveVariantNeeded: true,
                  handleFunction: () => {
                    if (selectedTransactions?.length >= conditionVarLengthOne) {
                      const selectedData = {
                        selectedSendTransactions,
                        selectedTransactions,
                        timestamp: Date.now(),
                      };
                      sessionStorage.setItem(
                        "selectedReimbursementRequestTxnData",
                        JSON.stringify(selectedData),
                      );
                      navigate(
                        "/field_force_transaction_dashboard/field_force_request_multi_approval/multi_approval",
                      );
                    }
                  },
                  enabledTextColor: "var(--primary-bg)",
                  isDisabled: !selectedTransactions?.length,
                  disabledBgColor: "var(--text-disabled)",
                  disabledTextColor: "var(--text-primary)",
                  hoverOption: "black",
                }}
                isToggleNeeded={true}
                toggleProps={{
                  state: false,
                  isDisabled: false,
                  title: "Single Approval",
                  handleClick: () => {
                    setDirection("");
                    navigate(
                      "/field_force_transaction_dashboard/field_force_request_single_approval",
                    );
                  },
                }}
                iconComponentArray={[
                  {
                    icon: ICONS?.SEARCH_WHITE,
                    title: "Search",
                    hoverOption: "white",
                    isLoading: false,
                    isDisabled: allBeneTxnAccountsLoading,
                    enabledBgColor:
                      initCategoryFilter ||
                      LabelSearchText?.length >
                        GlobalConfiguration.lengthCheckZero
                        ? "var(--text-primary)"
                        : "var(--primary-bg)",
                    handleFunction: () => setShowSearchBar((prev) => !prev),
                  },
                ]}
                filteredSearchProps={{
                  setShowInnerSearchBar,
                  showSearchBar,
                  isSearchDisabled: allBeneTxnAccountsLoading,
                  onSearchInput: handleSearch,
                  searchText: searchUserTextDebounce,
                  searchPlaceholder: "Search request",
                  filterPlaceholder: "reimbursement name",

                  filterItems: [
                    {
                      name: "Category",
                      valueType: "string",
                      short_name: "Cat",
                      isMulti: false,
                      value: initCategoryFilter,
                      setValue: (val) => {
                        const selectedCategory = inputData.find(
                          (category) =>
                            String(category?.id) === String(val) ||
                            category?.Category === val,
                        );
                        const categoryId = selectedCategory?.id ?? val;
                        const categoryName = selectedCategory?.Category ?? "";
                        setInitCategoryFilter(categoryId);
                        setDisplayCategory(categoryName);
                        setPage(GlobalConfiguration.lengthCheckOne);
                        const params = new URLSearchParams(
                          window.location.search,
                        );
                        params.delete("category");
                        params.set("category_id", String(categoryId));
                        if (categoryName) {
                          params.set("dispCat", categoryName);
                        } else {
                          params.delete("dispCat");
                        }
                        params.set(
                          "pageno",
                          String(GlobalConfiguration.lengthCheckOne),
                        );
                        navigate(
                          {
                            pathname: location.pathname,
                            search: `?${params.toString()}`,
                          },
                          { replace: true },
                        );
                      },
                      isDropdown: true,
                      isDisabled: allBeneTxnAccountsLoading,
                      displayValue: displayCategory,
                    },
                    {
                      name: "Labels",
                      valueType: "string",
                      short_name: "Lab",
                      isMulti: true,
                      value: label,
                      setValue: (val) => {
                        setPage(GlobalConfiguration.lengthCheckOne);
                        setlabel(val);
                        setLabelSearchText(val);
                        handleSubmit(
                          "label",
                          Array.isArray(val) ? val.join(",") : val,
                        );
                      },
                      isDropdown: true,

                      isDisabled: allBeneTxnAccountsLoading,
                    },
                  ],

                  isSearchClearAllDisabled: !(
                    initCategoryFilter?.length || LabelSearchText?.length
                  ),

                  inputData,
                  active,
                  setActive,
                  loading: loadingData,
                  setLoading: setLoadingData,
                  isShowFilter: false,
                }}
              />
            </div>
            <div
              ref={filterRef}
              className={`flex flex-col flex-1 overflow-y-auto  
              ${
                allAccounts?.length == GlobalConfiguration.lengthCheckZero ||
                allBeneTxnAccountsLoading
                  ? "pb-bottom-base"
                  : "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
              }`}
            >
              {showInnerSearchBar && (
                <div
                  className={
                    "absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"
                  }
                ></div>
              )}
              {/* Main Content Area */}
              <div
                className={`w-width-full overflow-y-auto scroll-py-top_md h-[-webkit-fill-available] z-z-index-content`}
                style={{
                  overflow: showInnerSearchBar ? "hidden" : "auto",
                  scrollPaddingTop: "var(--padding-md)",
                  scrollPaddingBottom: "var(--padding-md)",
                }}
                onScroll={handleScroll}
              >
                {allBeneTxnAccountsLoading ? (
                  <div
                    style={{
                      opacity: showInnerSearchBar
                        ? "var(--opcacity_none)"
                        : "var(--base-opacity)",
                    }}
                    className="loader-container m-auto justify-center items-center flex h-height-full"
                  >
                    <Loader />
                  </div>
                ) : !allAccounts?.length ? (
                  <div
                    className="int-txn-mutli-no-account-found"
                    style={{
                      opacity: showInnerSearchBar
                        ? "var(--light-opacity)"
                        : "var(--base-opacity)",
                    }}
                  >
                    <div className="flex justify-center items-center">
                      <img
                        src={
                          isFilterApplied
                            ? ICONS?.NO_DATA_FOUND
                            : ICONS?.NO_PENDING_TRANSACTION
                        }
                        className="w-graphic-width-md h-graphic-square-height-md int_txn_img"
                        alt="NoData"
                      />
                    </div>
                    <div className="int-txn-mutli-left-text-content-no-account !mt-margin-sm">
                      {isFilterApplied ? (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            No data found.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Clear Parameters"
                              handleFunction={handleClearParams}
                              enabledBgColor="var(--primary-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            There are no more request that require your
                            <br />
                            approval.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Go to dashboard"
                              handleFunction={() =>
                                navigate("/field_force_transaction_dashboard")
                              }
                              enabledBgColor="var(--primary-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${showInnerSearchBar ? "pointer-events-none" : "flex flex-col flex-1 items-center justify-center mx-auto bg-primary-bg"}`}
                  >
                    <FieldForceRequestTxnMultiCard
                      filterOpen={showInnerSearchBar}
                      setAllAccounts={setAllAccounts}
                      data={allAccounts}
                      selectedTransactions={selectedTransactions}
                      setSelectedTransactions={setSelectedTransactions}
                      totalAmount={totalAmount}
                      setselectAllCard={setselectAllCard}
                      setTotalAmount={setTotalAmount}
                      selectedSendTransactions={selectedSendTransactions}
                      setSelectedSendTransactions={setSelectedSendTransactions}
                      SideDrawerOpen={SideDrawerOpen}
                      openBeneTxnDetailModal={openBeneTxnDetailModal}
                      setTxnId={setTxnId}
                      setDatas={setDatas}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* Footer Section (Pagination & Mob Next Button) */}
          <div
            className={`flex flex-col absolute bottom-bottom-base ${showInnerSearchBar ? "opacity-light-opacity bg-PopUp-BackDrop pointer-events-none" : "opacity-base-opacity"}`}
          >
            {shouldShowPagination ? (
              <div className="z-z-index-content w-screen">
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={page}
                  setIsOpen={setIsOpen}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default FieldForceRequestMultiApproval;
